module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/level-6_start-0108fdb185105031dae57708118e2b3d.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/level-6_start.png
// module id = 904
// module chunks = 2